<template>
	<div class="twc-container">
		<BaseHeader title="상담하기" />
		<iframe class="twc-chat" :src="chatUrl"></iframe>
	</div>
</template>

<script>
import BaseHeader from '@/components/Base/BaseHeader.vue';
import useTheme from '@/composables/useTheme';
import { serviceMappers } from '@/model/mappers';
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

export default {
	name: 'Twc',
	components: { BaseHeader },
	setup() {
		const route = useRoute();
		const store = useStore();

		const serviceInfo = computed(() => store.state.common.serviceInfo);
		const serviceCode = route.params.serviceCode;
		const twcConfig = computed(() => store.getters['common/getTwcConfig']);

		const name = route.params.name;
		const phone = route.params.phone;

		const chatUrl = computed(
			() =>
				`https://webchat.thecloudgate.io/webChat?brandKey=${encodeURIComponent(
					twcConfig.value?.brandKey ?? '',
				)}&channelType=${
					twcConfig.value?.channelType ?? 'scenario'
				}&scenarioId=${encodeURIComponent(
					twcConfig.value?.scenarioId ?? '',
				)}&name=${encodeURIComponent(name)}&phone=${encodeURIComponent(phone)}`,
		);

		const setServiceStyle = style => {
			const serviceStyle = style || serviceMappers[serviceCode.toUpperCase()];
			if (!serviceStyle) {
				return;
			}
			useTheme(serviceStyle);
		};

		const getServiceInfo = async () => {
			const result = await store.dispatch('common/FETCH_SERVICE_INFO', {
				serviceCode: serviceCode?.toUpperCase(),
			});

			const style = result?.data?.contentProps?.style;
			setServiceStyle(style);
		};

		onMounted(() => {
			const style = serviceInfo.value?.contentProps?.style;
			Object.keys(serviceInfo.value).length
				? setServiceStyle(style)
				: getServiceInfo();
		});

		return { chatUrl };
	},
};
</script>

<style lang="scss" scoped>
.twc-container {
	width: 100%;
	height: 100%;
	max-width: 410px;
	margin: 0 auto;
}
:deep(.nav) {
	position: relative;
	width: 100%;
	margin: 0 auto;
	padding: 0 16px;
	background: #fff;
	box-sizing: border-box;

	h4 {
		@include horizon-center();
	}
}
.twc-chat {
	width: 100%;
	height: calc(100% - 54px);
}
</style>
